import { Popup, Popups } from '@models/popups'
import axios from 'axios'

const API_BASE_URL = process.env.DOMAIN || 'http://localhost:8101'

export async function fetchPopups(): Promise<Popup[]> {
  const url = `${API_BASE_URL}/api/cms/app-popups/`
  const { data } = await axios.get<Popups>(url, {
    params: { alternative_url: window.location.pathname.split('/').filter(Boolean)[0] },
  })
  return data.popups
}
